import { Doughnut, mixins } from 'vue-chartjs';

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: true,
      cutoutPercentage: 65,
      legend: { display: false },
      tooltips: {
        backgroundColor: 'rgba(17,24,39,0.9)',
        titleFontFamily: "'Instrument Sans', sans-serif",
        bodyFontFamily:  "'Instrument Sans', sans-serif",
        cornerRadius: 8,
        padding: 10,
        callbacks: {
          label(tooltipItem, data) {
            const label = data.labels[tooltipItem.index] || '';
            const val   = data.datasets[0].data[tooltipItem.index];
            return `  ${label}: ${val}`;
          },
        },
      },
      animation: {
        animateScale: true,
        animateRotate: true,
        duration: 800,
        easing: 'easeInOutQuart',
      },
      ...this.options,
    });
  },
};
